import * as React from 'react';
import StatusContext from '../../../contexts/StatusContext';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';


export const AlertDialog = ({alertYes, alertCancel, openDialog, closeDialog, prompt, canceltext}) => {

  let {
   changeLanguage,
} = React.useContext(StatusContext);

  const dialogStyle = {
    padding: "20px",
    fontSize: "16px",
 };
 
 const displayCancelText = canceltext || changeLanguage('dialog', 'cancel');
  return (
    <Dialog onClose = {closeDialog} open = {openDialog}>
            <DialogTitle style={{fontSize:'12px'}}> DedaAI </DialogTitle>
            <h3 style = {dialogStyle}>
               {prompt}
            </h3>
            <div style = {{display: 'flex', width: '100%', justifyContent:'center', alignItems: 'center'}}>
            <button className="alertpromptbuttonCancel" onClick={alertCancel}>{displayCancelText}</button> 
            <button className="alertpromptbuttonYes" onClick={alertYes}>{changeLanguage('dialog', 'yes')}</button> 
            
            </div>
    </Dialog>
  );
}
